"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 25" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M1 22V10.7019C1 10.0997 1.27139 9.52949 1.73881 9.14971L11.7388 1.02471C12.4736 0.427684 13.5264 0.427684 14.2612 1.02471L24.2612 9.14971C24.7286 9.52949 25 10.0997 25 10.7019V22C25 23.1046 24.1046 24 23 24H3C1.89543 24 1 23.1046 1 22Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M9 18C9 15.7909 10.7909 14 13 14V14C15.2091 14 17 15.7909 17 18V24H9V18Z", stroke: "black", strokeWidth: "1", fill: fill ? 'white' : 'transparent' }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 33" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M1 29.3333V14.2693C1 13.4662 1.36186 12.706 1.98509 12.1996L15.3184 1.36628C16.2982 0.570245 17.7018 0.570243 18.6816 1.36628L32.0149 12.1996C32.6381 12.706 33 13.4662 33 14.2693V29.3333C33 30.8061 31.8061 32 30.3333 32H3.66667C2.19391 32 1 30.8061 1 29.3333Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M11.6667 24C11.6667 21.0545 14.0545 18.6667 17 18.6667V18.6667C19.9455 18.6667 22.3334 21.0545 22.3334 24V32H11.6667V24Z", stroke: "black", strokeWidth: "1.5", fill: fill ? 'white' : 'transparent' }, void 0)] }), void 0));
};
var HomeIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.HomeIcon = HomeIcon;
//# sourceMappingURL=HomeIcon.js.map